export const FontSizes = {
  size10: '10px',
  size12: '12px',
  size14: '14px',
  size16: '16px',
  size18: '18px',
  size20: '20px',
  size24: '24px',
  size28: '28px',
  size32: '32px',
  size42: '42px',
  size68: '68px'
};
